module.exports = __webpack_public_path__ + "img/css_sprites-right-21.c883819.png";